/**
 * 节拍解析(BPWB-1,2026-09-03 从 features/video/model/blueprintStructure.ts 迁入):
 * beats15Raw(「0-3s 痛点;3-8s 演示;…」)→ 节拍数组。纯函数零 LLM。
 *
 * 迁入理由:蓝图工作卡(BlueprintHeroCard)要在视频舱之外(口播页)画节拍轨,
 * features 之间不许互相 import(FSD),节拍本来就是蓝图这个实体的派生 —— 归这层。
 * features/video/model/blueprintStructure.ts 原地 re-export,老引用与测试不动。
 */

export interface BlueprintBeat {
  label: string;
  start: number | null;
  end: number | null;
}

const BEAT_RE = /^(\d+(?:\.\d+)?)\s*[-~—至]+\s*(\d+(?:\.\d+)?)\s*[sS秒]?\s*(.*)$/;

/**
 * 节拍分隔符:半角 `;` + **全角 `；`** + 换行。
 *
 * ★2026-08-12:此前是 `/[;;]/` —— 看着像「中英文分号都收」,逐字节一看是两个
 * ASCII 分号(0x3b 0x3b),全角从来没被拆过。而 beats15Raw 是蒸馏 LLM 写的中文,
 * 半角/全角随机出(测试机 4 条真蓝图 1 条全角)。命中全角那次:整串塌成 1 拍,
 * 结构轨只剩一条、拍→镜映射全归拍 0、brief 底稿变成一大段。**间歇性坏**,
 * 所以从来没人报障 —— 老用例的标题甚至写着「按中英文分号拆」,只是没测过全角。
 */
const BEAT_SEP_RE = /[;；\n]/;

export function parseBeats(beats15Raw: string | null | undefined): BlueprintBeat[] {
  if (!beats15Raw) return [];
  return beats15Raw
    .split(BEAT_SEP_RE)
    .map((s) => s.trim())
    .filter(Boolean)
    .map((seg) => {
      const m = BEAT_RE.exec(seg);
      if (m && m[3]) {
        return { label: m[3].trim(), start: Number(m[1]), end: Number(m[2]) };
      }
      return { label: seg, start: null, end: null };
    });
}
